
import * as handlebars_family from "../handlebars_family.js";
import "../widget/specific/mprecipecat.js";
const TPL = handlebars_family.addTemplate("mealplanner/recipeCategoriesEditContent",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " <span class=\"mp-button-like mp-category "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"assigned") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":96},"end":{"line":1,"column":140}}})) != null ? stack1 : "")
    + "\" data-widget=\"widget/specific/mprecipecat\">";
  stack1 = ((helper = (helper = lookupProperty(helpers,"category") || (depth0 != null ? lookupProperty(depth0,"category") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"category","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":184},"end":{"line":1,"column":388}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"category")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " </span> ";
},"2":function(container,depth0,helpers,partials,data) {
    return "fw-background-branded";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"emoji") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":198},"end":{"line":1,"column":279}}})) != null ? stack1 : "")
    + " <input type=\"hidden\" name=\"recipe.recipeCategoryIdList\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"computedName") : depth0), depth0));
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji> ";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "</icon> ";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"mp-button-like mp-category\" data-fw-onclick=\""
    + ((stack1 = lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),"recipecatlist",{"name":"premiumPermission","hash":{},"data":data,"loc":{"start":{"line":1,"column":504},"end":{"line":1,"column":543}}})) != null ? stack1 : "")
    + "\"><icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_more_horizontal",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":551},"end":{"line":1,"column":583}}}))
    + "</icon>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.categoriesMore",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":590},"end":{"line":1,"column":620}}})) != null ? stack1 : "")
    + "</span> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.category",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":3},"end":{"line":1,"column":27}}})) != null ? stack1 : "")
    + "</p><p> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"categories") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":35},"end":{"line":1,"column":406}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),"recipecatlist",{"name":"premiumPermission","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":407},"end":{"line":1,"column":650}}})) != null ? stack1 : "")
    + " </p> ";
},"useData":true});
export default TPL;